/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import httpClient from 'utils/httpClient';

export const RETRIEVE_TEACHING_STATUS = '/v2/teacher/teaching-status';

export type RetrieveTeachingStatusResponse = {
  isReady: number;
};

export const retrieveTeachingStatus = () =>
  httpClient.get<RetrieveTeachingStatusResponse>(RETRIEVE_TEACHING_STATUS);

export const useRetrieveTeachingStatus = (
  opts?: UseQueryOptions<
    AxiosResponse<RetrieveTeachingStatusResponse>,
    AxiosError<any>
  >,
) => {
  return useQuery<
    AxiosResponse<RetrieveTeachingStatusResponse>,
    AxiosError<any>
  >([RETRIEVE_TEACHING_STATUS], () => retrieveTeachingStatus(), {
    retry: false,
    cacheTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
